export default "/StatisticheIsaWeb/dist/img/isa_statistiche_logo.png";